import React from 'react';
import {Link, useLocation, useParams} from 'react-router-dom';
import {useTranslation} from '../../../hook/useTranslation';
import Button from '../../button/Button';
import Contact from '../../contact/Contact';
import {arbeitsgruppen, projekte, thementraegerinnen, nachwuchsprogramm} from './../../../icons/icons';
import './Model.scss';

export default function LayoutModel() {
    const location = useLocation();
    const {translationPath} = useParams<'translationPath'>();
    const i18n = useTranslation();

    return (
        <div className="career-model__model">
            <div className="career-model__model--header">
                <Button text="Back"
                        uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.back_link`)}
                        additionalClass="icon-only icon-back"/>
            </div>
            <div className="career-model__model--content">
                <h1 className="career-model__model--title">{i18n.translate(`show.items.${translationPath}.title`)}</h1>
                {i18n.translate(`show.items.${translationPath}.subtitle`) &&
                    <h2 className="career-model__model--sub-title">{i18n.translate(`show.items.${translationPath}.subtitle`)}</h2>
                }
                <p className="career-model__model--desc"
                   dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.description`)}}></p>
                {i18n.translate(`show.items.${translationPath}.links.more_link`) &&
                    <Button text={i18n.translate(`show.items.${translationPath}.links.more_label`)}
                            uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.more_link`)}
                            additionalClass="size-sm"/>
                }
                {i18n.translate(`show.items.${translationPath}.items_title`) &&
                    <h2 className="career-model__model--items-title">{i18n.translate(`show.items.${translationPath}.items_title`)}</h2>
                }
                <div className="career-model__model--links">
                    {i18n.keyExists(`show.items.${translationPath}.items.0.title`) &&
                        <div className="career-model__model--link-1">
                            <div className="career-model__model--icon-1"
                                 dangerouslySetInnerHTML={{__html: arbeitsgruppen}}></div>
                            <Link
                                to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.0.link`)}
                                state={{backgroundLocation: location}}>
                                {i18n.translate(`show.items.${translationPath}.items.0.title`)}
                            </Link>
                        </div>
                    }
                    {i18n.keyExists(`show.items.${translationPath}.items.1.title`) &&
                        <div className="career-model__model--link-2">
                            <div className="career-model__model--icon-2"
                                 dangerouslySetInnerHTML={{__html: projekte}}></div>
                            <Link
                                to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.1.link`)}
                                state={{backgroundLocation: location}}>
                                {i18n.translate(`show.items.${translationPath}.items.1.title`)}
                            </Link>
                        </div>
                    }
                    {i18n.keyExists(`show.items.${translationPath}.items.2.title`) &&
                        <div className="career-model__model--link-3">
                            <div className="career-model__model--icon-3"
                                 dangerouslySetInnerHTML={{__html: thementraegerinnen}}></div>
                            <Link
                                to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.2.link`)}
                                state={{backgroundLocation: location}}>
                                {i18n.translate(`show.items.${translationPath}.items.2.title`)}
                            </Link>
                        </div>
                    }
                    {i18n.keyExists(`show.items.${translationPath}.items.3.title`) &&
                        <div className="career-model__model--link-4">
                            <div className="career-model__model--icon-4"
                                 dangerouslySetInnerHTML={{__html: nachwuchsprogramm}}></div>
                            <Link
                                to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.3.link`)}
                                state={{backgroundLocation: location}}>
                                {i18n.translate(`show.items.${translationPath}.items.3.title`)}
                            </Link>
                        </div>
                    }
                </div>
            </div>
            <div className="career-model__model--footer">
                <Button text={i18n.translate(`show.items.${translationPath}.links.previous_label`)}
                        uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.previous_link`)}
                        additionalClass="icon-back"/>
                <Button text={i18n.translate(`show.items.${translationPath}.links.next_label`)}
                        uri={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.links.next_link`)}
                        additionalClass="icon-forward"/>
            </div>
            {
                i18n.keyExists(`show.items.${translationPath}.override.contact.person.name`) ? (
                    <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                             person={{
                                 email: i18n.translate(`show.items.${translationPath}.override.contact.person.email`),
                                 emailLabel: i18n.translate(`show.items.${translationPath}.override.contact.person.email-label`),
                                 image: i18n.translate(`show.items.${translationPath}.override.contact.person.image`),
                                 name: i18n.translate(`show.items.${translationPath}.override.contact.person.name`),
                                 phone: i18n.translate(`show.items.${translationPath}.override.contact.person.phone`),
                                 title: i18n.translate(`show.items.${translationPath}.override.contact.person.title`)
                             }}/>
                ) : (
                    i18n.keyExists(`show.items.${translationPath}.override.contact.text`) ? (
                        <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                                 text={i18n.translate(`show.items.${translationPath}.override.contact.text`)}/>
                    ) : (
                        <Contact title={i18n.translate('show.contact.title')}
                                 person={{
                                     email: i18n.translate('show.contact.person.email'),
                                     emailLabel: i18n.translate('show.contact.person.email-label'),
                                     image: i18n.translate('show.contact.person.image'),
                                     name: i18n.translate('show.contact.person.name'),
                                     phone: i18n.translate('show.contact.person.phone'),
                                     title: i18n.translate('show.contact.person.title')
                                 }}/>
                    )
                )}
        </div>
    );
};
